import { platformBrand } from "../../shared/platform-brand";

export function BrandLogo() {
  return (
    <>
      <img
        className="brand-symbol"
        src="/assets/brand/juyici-mark.svg"
        alt=""
        width={44}
        height={44}
      />
      <div className="brand-type">
        {platformBrand.name}
        <span>{platformBrand.domain}</span>
      </div>
    </>
  );
}
